import * as authActionTypes from "../Actions/Auth/ActionTypes";
import * as mainActionTypes from "../Actions/Main/ActionTypes";
import * as planActionTypes from "../Actions/Plan/ActionTypes";
import * as hubActionTypes from "../Actions/MicroHubs/ActionTypes";
import * as planViewActionTypes from "../Actions/PlanView/ActionTypes";
import * as DriverLogActionTypes from "../Actions/DriverLog/ActionTypes";
import * as AnalyticsActionTypes from "../Actions/Analytics/ActionTypes";
import * as DriverManagementActionTypes from "../Actions/DriverManagement/ActionTypes";

import { getAllDataSaga } from "./Analytics/AnalyticsSaga";
import { getDriverLogSaga } from "./DriverLogSaga/DriverLogSaga";
import { takeEvery, takeLatest } from "redux-saga/effects";
import { connectMQTTSaga, connectSocketSaga } from "./MainSaga/MainSaga";
import {
  checkUserNameSaga,
  getHelpicalTokenSaga,
  getUserSaga,
  loginUserByKeySaga,
  loginUserSaga,
} from "./AuthSaga/AuthSaga";

import * as PlanSaga from "./PlanSaga/PlanSaga";
import * as DriverSaga from "./DriverManagementSaga/DriverManagementSaga";
import * as PlanViewSaga from "./PlanViewSaga/PlanViewSaga";
import * as MicrohubSaga from "./MicroHubsSaga/MicroHubsSaga";

export function* watchMain() {
  yield takeLatest(mainActionTypes.MQTT_CONNECTION, connectMQTTSaga);
  yield takeLatest(mainActionTypes.WEBSOCKET_CONNECTION, connectSocketSaga);
}

export function* watchHub() {
  yield takeLatest(hubActionTypes.EDIT_HUB, MicrohubSaga.editHubSaga);
  yield takeLatest(hubActionTypes.CREATE_HUB, MicrohubSaga.createHubSaga);
  yield takeLatest(hubActionTypes.DELETE_HUB, MicrohubSaga.deleteHubSaga);
  yield takeLatest(hubActionTypes.GET_ALL_HUBS, MicrohubSaga.getHubsSaga);
  yield takeLatest(hubActionTypes.GET_HUB_BY_ID, MicrohubSaga.getHubByIdSaga);
  yield takeLatest(
    hubActionTypes.ASSIGN_POLYGON_TO_HUB,
    MicrohubSaga.assignPolygonToHubSaga
  );
  yield takeLatest(
    hubActionTypes.REMOVE_HUB_FROM_POLYGON,
    MicrohubSaga.removeHubFromPolygonSaga
  );
}

export function* watchAuth() {
  yield takeLatest(authActionTypes.LOGIN_USER, loginUserSaga);
  yield takeLatest(authActionTypes.GET_CURRENT_USER, getUserSaga);
  yield takeLatest(authActionTypes.LOGIN_USER_BY_KEY, loginUserByKeySaga);
  yield takeLatest(authActionTypes.CHECK_USERNAME_EXIST, checkUserNameSaga);
  yield takeLatest(authActionTypes.GET_HELPICAL_TOKEN, getHelpicalTokenSaga);
}

export function* watchPlan() {
  yield takeLatest(planActionTypes.GET_PLANS, PlanSaga.getPlansSaga);
  yield takeLatest(planActionTypes.CREATE_PLAN, PlanSaga.createPlanSaga);
  yield takeLatest(planActionTypes.DELETE_PLAN, PlanSaga.deletePlanSaga);
  yield takeLatest(planActionTypes.UPDATE_PLAN, PlanSaga.updatePlanSaga);
  yield takeLatest(planActionTypes.RESTORE_PLAN, PlanSaga.restorePlanSaga);
  yield takeLatest(planActionTypes.EXECUTE_PLAN, PlanSaga.executePlanSaga);
  yield takeLatest(planActionTypes.GET_PLAN_LOGS, PlanSaga.getPlanLogsSaga);
  yield takeLatest(planActionTypes.GET_ALL_PLANS, PlanSaga.getAllPlansSaga);
  yield takeLatest(planActionTypes.RESTORE_DRIVER, PlanSaga.restoreDriverSaga);
  yield takeLatest(
    planActionTypes.POST_PLAN_CONFIG,
    PlanSaga.postPlanConfigSaga
  );
  yield takeLatest(
    planActionTypes.GET_TOOLNAME_LIST,
    PlanSaga.getToolNameListSaga
  );
  yield takeLatest(
    planActionTypes.DOWNLOAD_PLAN_FORM,
    PlanSaga.downloadPlanFormSaga
  );
  yield takeLatest(
    planActionTypes.ERROR_PLAN_MESSAGE,
    PlanSaga.errorPlanMessageSaga
  );
  yield takeLatest(
    planActionTypes.DOWNLOAD_EXCEL_FILE,
    PlanSaga.downloadExcelFileSaga
  );
  yield takeLatest(
    planActionTypes.MISSION_INFO_BY_ORDER_ID,
    PlanSaga.MissionInfoByIdSaga
  );
  yield takeLatest(
    planActionTypes.GET_FROM_EXTERNAL_SOURCE,
    PlanSaga.getFromExternalSourceSaga
  );
  yield takeEvery(
    planActionTypes.DOWNLOAD_OPTIMIZE_FILE,
    PlanSaga.downloadOptimizeFileSaga
  );
}

export function* watchDriverManagement() {
  yield takeLatest(
    DriverManagementActionTypes.CREATE_DRIVER_WITH_FILE,
    DriverSaga.creacteDriverWithfileSaga
  );
  yield takeLatest(
    DriverManagementActionTypes.CREATE_DISTRIBUTOR,
    DriverSaga.CreateDistributorSaga
  );
  yield takeLatest(
    DriverManagementActionTypes.CHANGE_DRIVER_PASSWORD,
    DriverSaga.changeDriverPasswordSaga
  );
  yield takeLatest(
    DriverManagementActionTypes.DELETE_DRIVER,
    DriverSaga.deleteDriverSaga
  );
  yield takeLatest(
    DriverManagementActionTypes.EDIT_DRIVER,
    DriverSaga.editDriverSaga
  );
  yield takeLatest(
    DriverManagementActionTypes.CREATE_DRIVER_WITH_VEHICLE,
    DriverSaga.createDriverWithVehicleSaga
  );
  yield takeLatest(
    DriverManagementActionTypes.GET_ALL_DRIVER_OF_PLAN,
    DriverSaga.getAllDriversOfPlanSaga
  );
  yield takeLatest(
    DriverManagementActionTypes.GET_DRIVER,
    DriverSaga.getDriverSaga
  );
  yield takeLatest(
    DriverManagementActionTypes.SEARCH_TENANT_DRIVERS,
    DriverSaga.searchTenantDriversSaga
  );
  yield takeLatest(
    DriverManagementActionTypes.SEARCH_TENANT_DRIVER_PERSONAL,
    DriverSaga.searchTenantDriverPersonalSaga
  );
  yield takeLatest(
    DriverManagementActionTypes.POST_DRIVER_INFO,
    DriverSaga.postDriverInfoSaga
  );
  yield takeLatest(
    DriverManagementActionTypes.ACTIVE_MISSION_TO_DRIVER,
    DriverSaga.activeMissionToDriverSaga
  );
  yield takeLatest(
    DriverManagementActionTypes.DELETE_MISSION_FROM_DRIVER,
    DriverSaga.DeleteMissionFromDriverSaga
  );
}

export function* watchView() {
  yield takeLatest(planViewActionTypes.PLAN_RESET, PlanViewSaga.planResetSaga);
  yield takeLatest(
    planViewActionTypes.GET_PLAN_INFO,
    PlanViewSaga.getPlanInfoSaga
  );
  yield takeLatest(
    planViewActionTypes.UPLOAD_LAST_PIN,
    PlanViewSaga.uploadLastPin
  );
  yield takeLatest(
    planViewActionTypes.GET_CITY_LAYERS,
    PlanViewSaga.getCityLayerSaga
  );
  yield takeLatest(
    planViewActionTypes.GET_PLAN_STATUS,
    PlanViewSaga.getPlanStatusSaga
  );
  yield takeLatest(
    planViewActionTypes.AUTO_DRIVER_ASSIGN,
    PlanViewSaga.autoAssignSaga
  );
  yield takeLatest(
    planViewActionTypes.REQUEST_VEHICLE,
    PlanViewSaga.requestVehicleSaga
  );
  yield takeLatest(
    planViewActionTypes.GET_MISSION_INFO,
    PlanViewSaga.getMissionInfoSaga
  );
  yield takeLatest(
    planViewActionTypes.GET_ACTUAL_ROUTE,
    PlanViewSaga.getActualRouteSaga
  );
  yield takeLatest(
    planViewActionTypes.GET_CHAT_MESSAGES,
    PlanViewSaga.getChatMessagesSaga
  );
  yield takeLatest(
    planViewActionTypes.CONFIRM_LAST_PIN,
    PlanViewSaga.confirmLastPinSaga
  );
  yield takeLatest(
    planViewActionTypes.EDIT_VEHICLE_NAME,
    PlanViewSaga.EditVehicleNameSaga
  );
  yield takeLatest(
    planViewActionTypes.DRIVER_ACTIVATION,
    PlanViewSaga.driverActivationSaga
  );
  yield takeLatest(
    planViewActionTypes.GET_NEXT_PREV_PLAN,
    PlanViewSaga.getNextPrevPlanSaga
  );
  yield takeLatest(
    planViewActionTypes.CHANGE_MISSION_STATUS,
    PlanViewSaga.changeStatusSaga
  );
  yield takeLatest(
    planViewActionTypes.GET_LIVETRACK_INFO,
    PlanViewSaga.getLivetrackInfoSaga
  );
  yield takeLatest(
    planViewActionTypes.ADD_NEW_PIN_TO_PLAN,
    PlanViewSaga.AddNewPinToPlanSaga
  );
  yield takeLatest(
    planViewActionTypes.DISPATCH_TO_DRIVER,
    PlanViewSaga.DispatchToDriverSaga
  );
  yield takeLatest(
    planViewActionTypes.SEARCH_IN_LIVETRACK,
    PlanViewSaga.searchLiveTrackSaga
  );
  yield takeLatest(
    planViewActionTypes.GET_PLAN_LIGHT_INFO,
    PlanViewSaga.getPlanLightInfoSaga
  );
  yield takeLatest(
    planViewActionTypes.GET_ALL_MISSION_POD,
    PlanViewSaga.getAllMissionPodSaga
  );
  yield takeLatest(
    planViewActionTypes.GET_REMAIN_PIN_COORDS,
    PlanViewSaga.getRemainCoordsSaga
  );
  yield takeLatest(
    planViewActionTypes.CHANGE_MISSIONS_ORDER,
    PlanViewSaga.changeMissionsOrderSaga
  );
  yield takeLatest(
    planViewActionTypes.GET_LIVETRACK_DRIVERS,
    PlanViewSaga.getLiveTrackDriversSaga
  );
  yield takeLatest(
    planViewActionTypes.AUTO_ASSIGN_MICROHUBS,
    PlanViewSaga.autoAssignMicrohubsSaga
  );
  yield takeLatest(
    planViewActionTypes.GET_DRIVER_MISSION_INFO,
    PlanViewSaga.getDriverMissionInfoSaga
  );
  yield takeLatest(
    planViewActionTypes.GET_MISSION_STATUS_EXCEL,
    PlanViewSaga.getMissionStatusExcelSaga
  );
  yield takeEvery(
    planViewActionTypes.GET_MISSION_CONFIRMATION,
    PlanViewSaga.getMissionConfirmationSaga
  );
  yield takeLatest(
    planViewActionTypes.SET_MISSION_CONFIRMATION,
    PlanViewSaga.setMissionConfirmationSaga
  );
  yield takeLatest(
    planViewActionTypes.REMOVE_DRIVER_FROM_POLYGON,
    PlanViewSaga.removeDriverFromPolygonSaga
  );
  yield takeLatest(
    planViewActionTypes.GET_ACTUAL_DELIVERY_MISSION,
    PlanViewSaga.getActualDeliveryMissionSaga
  );
  yield takeLatest(
    planViewActionTypes.GET_DRIVER_MISSION_INFO_COUNT,
    PlanViewSaga.getDriverMissionInfoCountSaga
  );
  yield takeLatest(
    planViewActionTypes.REMOVE_DISTRIBUTOR_FROM_POLYGON,
    PlanViewSaga.removeDistributorFromPolygonSaga
  );
}

export function* watchDriverLog() {
  yield takeLatest(DriverLogActionTypes.GET_DRIVER_LOG, getDriverLogSaga);
}

export function* watchAnalytics() {
  yield takeLatest(AnalyticsActionTypes.GET_DATA, getAllDataSaga);
}
